import { render, staticRenderFns } from "./pmsConetionsDetails.vue?vue&type=template&id=2e4946f4"
import script from "./pmsConetionsDetails.vue?vue&type=script&lang=js"
export * from "./pmsConetionsDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports